<template>
  <validation-observer ref="FormValidation">
    <b-form @submit.prevent="onSubmit">
      <b-form-row class="align-items-center px-50 justify-content-between">
        <h4>المعلومات الأساسية</h4>
        <loader-btn :loading="working" type="submit" variant="success" />
      </b-form-row>
      <b-form-row>
        <b-col cols="12">
          <hr />
        </b-col>

        <b-col cols="6">
          <form-input
            v-model="form.name"
            rules="required"
            label="اسم المشروع"
          />
        </b-col>

        <b-col cols="6">
          <form-input
            v-model="form.code"
            rules="required"
            label="رقم المشروع"
          />
        </b-col>
        <b-col cols="6">
          <form-select
            rules="required"
            id="UNs"
            ep="v2/selects/un-agents"
            label="اسم منظمة الأمم المتحدة"
            v-model="form.u_n_agent_id"
            :getOptionLabel="(x) => x.name"
            :reduce="(x) => x.id"
          />
        </b-col>
        <b-col cols="6">
          <form-mask
            options="date"
            placeholder="YYYY-MM-DD"
            v-model="form.register_date"
            rules="required"
            label="تاريخ التسجيل"
            id="register-year"
          />
        </b-col>
        <b-col cols="6">
          <form-currency
            v-model="form.expected_budget"
            rules="required"
            label="الميزانية الإجمالية المرصودة"
          />
        </b-col>
        <b-col cols="6">
          <form-input
            v-model="form.cooperation_relation"
            rules="required"
            label="الصلة بموضوع التعاون"
          />
        </b-col>
        <b-col cols="6">
          <form-cleave
            v-model="form.duration_by_months"
            rules="required"
            isNumber
            label="مدة المشروع بالأشهر"
          />
        </b-col>
        <b-col cols="6">
          <form-cleave
            rules="required"
            v-model="form.ben_number"
            label="العدد الإجمالي للمستفيدين"
            isNumber
          />
        </b-col>
        <b-col cols="6">
          <b-form-row>
            <b-col>
              <form-cleave
                v-model="form.working_employees_number"
                rules="required"
                isNumber
                label="عدد موظفي الجمعية في المشروع"
              />
            </b-col>
            <b-col>
              <form-cleave
                v-model="form.total_employees_number"
                rules="required"
                isNumber
                label="من أصل"
                name="إجمالي الموظفين"
              />
            </b-col>
          </b-form-row>
        </b-col>
        <b-col cols="6">
          <b-form-row>
            <b-col>
              <form-cleave
                v-model="form.working_volunteers_number"
                rules="required"
                isNumber
                label="عدد متطوعي الجمعية في المشروع"
              />
            </b-col>
            <b-col>
              <form-cleave
                v-model="form.total_volunteers_number"
                rules="required"
                isNumber
                label="من أصل"
                name="إجمالي المتطوعين"
              />
            </b-col>
          </b-form-row>
        </b-col>
        <b-col cols="6">
          <b-form-row>
            <b-col cols="4">
              <form-cleave
                v-model="form.total_vacancies_number"
                rules="required"
                isNumber
                label="عدد فرص العمل"
              />
            </b-col>
            <b-col cols="4">
              <form-cleave
                v-model="form.perma_vacancies_number"
                rules="required"
                isNumber
                label="الدائمة"
              />
            </b-col>
            <b-col cols="4">
              <form-cleave
                v-model="form.tempo_vacancies_number"
                rules="required"
                isNumber
                label="المؤقتة"
              />
            </b-col>
          </b-form-row>
        </b-col>
      </b-form-row>
    </b-form>
  </validation-observer>
</template>

<script>
import { BButton, BFormRow, BCol, BForm } from "bootstrap-vue";
import { ValidationObserver } from "vee-validate";
import FormInput from "@/components/form-input";
import FormSelect from "@/components/form-select";
import FormMask from "@/components/form-mask";
import FormCleave from "@/components/FormCleave.vue";
import LoaderBtn from "@/components/loader-btn.vue";
import FormCurrency from "@/components/FormCurrency.vue";
import { mapGetters } from "vuex";

export default {
  components: {
    FormInput,
    BButton,
    BFormRow,
    BCol,
    LoaderBtn,
    BForm,
    ValidationObserver,
    FormSelect,
    FormMask,
    FormCleave,
    FormCurrency,
  },
  data() {
    return {
      form: {},
    };
  },
  computed: {
    ...mapGetters("UNCoop", ["working"]),
  },
  methods: {
    init(form = {}) {
      this.form = JSON.parse(JSON.stringify(form));
    },
    async onSubmit() {
      await this.$refs.FormValidation.validate().then(async (success) => {
        if (success) this.$emit("confirm", this.form);
      });
    },
  },
};
</script>
